<template>
  <div>
    <span class="label info-list__label" v-text="label"></span>

    <div class="mb-4"
         v-for="(text, index) in value" :key="index">
                  <textarea class="info-list__textarea"
                            :class="{ 'is-active': isActive}"
                            placeholder="Не заполнено" v-autogrow
                            v-model="value[index]"
                            :disabled="!isActive"></textarea>
    </div>

    <transition name="fade">
      <el-button
          v-if="isActive"
          plain
          size="mini"
          icon="el-icon-plus"
          @click.prevent="addNewItem"
      > {{this.addButtonText}}
      </el-button>
    </transition>

  </div>
</template>

<script>
export default {
  name: "RepeatableTextField",
  model: {
    prop: 'value',
  },
  props: {
    value: Array,
    isActive: {
      type: Boolean,
      default: true,
    },
    label: {
      type: String,
      default: '',
    },
    addButtonText: {
      type: String,
      default: 'Добавить',
    }
  },
  methods: {
    addNewItem() {
      this.value.push('');
    },
  }
}
</script>